import {useDialogStore} from '@ariakit/react'
import {
    Dialog,
    DialogBody,
    DialogDismiss,
    DialogFooter,
    DialogHeader,
    DialogHeading,
    DialogProvider
} from '@/components/ui/dialog-atoms/DialogAtoms'
import {Button} from '@/components/ui/button/Button'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {Text} from '@/components/ui/text/Text'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {TKey, useTranslation} from '@/translations/i18n'

type ConfirmActivityReportActionDialogProps = {
    isOpen: boolean
    onClose: () => void
    title: TKey
    description: TKey
    confirmLabel: TKey
    isPending: boolean
    onConfirm: () => void
}

// Shared confirmation for the irreversible "mark as billed" and "delete" actions (FR-025).
export const ConfirmActivityReportActionDialog = ({
    isOpen,
    onClose,
    title,
    description,
    confirmLabel,
    isPending,
    onConfirm
}: ConfirmActivityReportActionDialogProps) => {
    const {t} = useTranslation()
    const dialogStore = useDialogStore({
        open: isOpen,
        setOpen: nextOpen => {
            if (!nextOpen) onClose()
        }
    })

    return (
        <DialogProvider store={dialogStore}>
            <Dialog width="400px" overflowY="unset" onClick={event => event.stopPropagation()}>
                <DialogHeader>
                    <DialogHeading>{t(title)}</DialogHeading>
                    <DialogDismiss />
                </DialogHeader>
                <DialogBody>
                    <Flexbox direction="column" gap={4}>
                        <Text size="textSm" palette="neutral" shade="700">
                            {t(description)}
                        </Text>
                        <Text size="textXs" palette="neutral" shade="600">
                            {t('activity_report:action_irreversible')}
                        </Text>
                    </Flexbox>
                </DialogBody>
                <DialogFooter>
                    <Button variant="secondary" onClick={onClose} disabled={isPending}>
                        {t('commons:cancel')}
                    </Button>
                    <Button variant="primaryNeutral" onClick={onConfirm} disabled={isPending}>
                        {t(confirmLabel)}
                        {isPending && <Spinner />}
                    </Button>
                </DialogFooter>
            </Dialog>
        </DialogProvider>
    )
}
